import React, { useEffect } from "react";
import Obgcon from "./Obgcon";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Obg() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Obgcon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best Gynaecology Clinic in Whitefield</title>
        <meta
          name="description"
          content="We are the best gynaecology Clinic in Whitefield and Vijayanagar. Feel free to contact us if you are looking for this."
        />
        <meta
          name="keywords"
          content="Best Gynaecology Clinic in Whitefield, Best Gynaecology Clinic in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id": "https://www.elvhealthcare.com/bestobgservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestobgservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield provides comprehensive obstetrics and gynecology (OBG) services including prenatal care, pregnancy monitoring, gynecological consultations, family planning, and women’s health support by experienced specialists.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Prenatal care and pregnancy monitoring",
              "Gynecological consultations and exams",
              "Family planning and reproductive health",
              "Menstrual disorder management",
              "Pelvic pain and hormone care",
              "Ultrasound and maternal health scans",
              "Postnatal care and counseling",
            ],
            keywords: [
              "best obg services in Immadihalli",
              "best obg services in Whitefield",
              "best obg services in Bangalore",
              "best obg services in Kundalahalli",
              "best obg services in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        Best Gynaecology Clinic in Whitefield apart as a leader in Obstetrics
        and Gynecology services. Contact us as we are the best gynaecology
        Clinic in Whitefield.
      </h2>
      <Servicebanner
        name="Obstetrics and Gynecology"
        banner={"../photo/dd15.jpg"}
      />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
            <Divider />
          </div>
          <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Obg;
